import React from "react";
import { DotFlash } from "../styled/LoaderFade.styled";

export default function LoaderFade() {
  return (
    <>
      <DotFlash />
    </>
  );
}
